import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Building2,
  Users,
  Shield,
  UserCircle,
  Factory,
  ChevronRight,
} from "lucide-react";
import AdminStatCard from "./AdminStatCard";

const AdminHeroSection = ({ stats }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="px-6 pb-6 pt-5">
      <div className="mb-5 flex items-start justify-between">
        <div>
          <h1 className="text-xl font-bold text-[#111827]">
            {t("admin.superUser.hero.title")}
          </h1>
          <p className="mt-0.5 text-xs text-[#6B7280]">
            {t("admin.superUser.hero.subtitle")}
          </p>
        </div>
        <button
          onClick={() => navigate("/v2/admin/manufacturing")}
          className="flex items-center gap-1.5 rounded-[10px] border border-[#E5E7EB] bg-white px-4 py-2.5 text-sm font-medium text-[#374151] transition duration-150 hover:bg-[#F9FAFB]"
        >
          <Factory size={15} className="text-[#E07A3A]" />
          {t("admin.superUser.hero.manufacturing")}
          {stats.wearables > 0 && (
            <span className="rounded-full bg-[#FFF3ED] px-2 py-0.5 text-xs font-semibold text-[#E07A3A]">
              {stats.wearables.toLocaleString()}
            </span>
          )}
          <ChevronRight size={15} className="text-[#9CA3AF]" />
        </button>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <AdminStatCard
          icon={Building2}
          label={t("admin.superUser.hero.totalWorkspaces")}
          value={stats.totalWorkspaces}
        />
        <AdminStatCard
          icon={Users}
          label={t("admin.superUser.hero.totalUsers")}
          value={stats.totalUsers}
        />
        <AdminStatCard
          icon={Shield}
          label={t("admin.superUser.hero.totalTeams")}
          value={stats.totalTeams}
        />
        <AdminStatCard
          icon={UserCircle}
          label={t("admin.superUser.hero.totalAthletes")}
          value={stats.totalPlayers}
        />
      </div>
    </div>
  );
};

export default AdminHeroSection;
